import {
  buildLegalDocumentActions,
  createLegalDocumentSelections,
  hasRequiredLegalSelections,
} from '../../legal/lib/legalDocuments'

const SIGN_UP_AGREEMENTS_STORAGE_KEY = 'akive.sign-up-legal-documents'

export const createInitialMembershipAgreements = headers => (
  createLegalDocumentSelections(headers || [])
)

export const hasRequiredMembershipAgreements = (agreements, headers = []) => (
  hasRequiredLegalSelections(headers, agreements)
)

export const hasSameMembershipDocuments = (left = [], right = []) => {
  if (left.length !== right.length) return false
  return left.every((header, index) => (
    header.legalDocumentId === right[index]?.legalDocumentId
    && header.version === right[index]?.version
  ))
}

export const createMembershipLegalActions = ({
  headers,
  previousActions = [],
  selections,
}) => {
  const previousRequestIds = previousActions.reduce((requestIds, action) => ({
    ...requestIds,
    [action.legalDocumentId]: action.requestId,
  }), {})

  return buildLegalDocumentActions({
    headers,
    requestIdsByDocumentId: previousRequestIds,
    selections,
  })
}

export const savePendingMembershipAgreements = draft => {
  try {
    window.sessionStorage.setItem(SIGN_UP_AGREEMENTS_STORAGE_KEY, JSON.stringify(draft))
    return true
  } catch {
    return false
  }
}

export const getMembershipAgreementDraft = () => {
  try {
    const storedValue = window.sessionStorage.getItem(SIGN_UP_AGREEMENTS_STORAGE_KEY)
    if (!storedValue) return null

    const draft = JSON.parse(storedValue)
    if (!Array.isArray(draft?.headers) || !draft?.selections) return null
    return {
      headers: draft.headers,
      selections: draft.selections,
      legalDocumentActions: Array.isArray(draft.legalDocumentActions)
        ? draft.legalDocumentActions
        : [],
    }
  } catch {
    return null
  }
}

export const getPendingMembershipAgreements = () => {
  const draft = getMembershipAgreementDraft()
  if (!draft || !hasRequiredMembershipAgreements(draft.selections, draft.headers)) return null
  if (draft.legalDocumentActions.length !== draft.headers.length) return null
  return draft
}

export const clearPendingMembershipAgreements = () => {
  try {
    window.sessionStorage.removeItem(SIGN_UP_AGREEMENTS_STORAGE_KEY)
  } catch {
    // 저장소 접근이 제한된 환경에서도 회원가입 완료 흐름을 유지한다.
  }
}
